module.exports = __webpack_public_path__ + "img/color-2.caad198.png";